module.exports = __webpack_public_path__ + "img/france-flag.6f703743.svg";